<template lang="pug">
b-nav.menu(vertical)
  b-nav-item(ref="profile",@click="handleTab('profile')",:class="feature === 'profile' ? 'active' : ''")
    i.icon.fas.fa-user
    span マイプロフィール
  //-b-nav-item(ref="password",@click="doResetPassword()",:class="feature === 'password' ? 'active' : ''")
    i.icon.fas.fa-key
    span パスワードのリセット
  b-nav-item(ref="preference",@click="handleTab('preference')",:class="feature === 'preference' ? 'active' : ''")
    i.icon.fas.fa-paper-plane
    span 通知設定
  template(v-if="currentUser && currentUser.acl && currentUser.acl.billings && currentUser.acl.billings.get && (currentUser.role === 'admin' || currentUser.role === 'master')")
    b-nav-item(ref="billings",@click="handleTab('billings')",:class="feature === 'billings' ? 'active' : ''")
      i.icon.fas.fa-receipt
      span 請求書・領収書
    b-nav-item(ref="payment",@click="handleTab('payment')",:class="feature === 'payment' ? 'active' : ''")
      i.icon.fas.fa-credit-card
      span お支払い方法
  b-nav-item(ref="company",@click="handleTab('company')",:class="feature === 'company' ? 'active' : ''")
    i.icon.fas.fa-building
    span 会社情報
  template(v-if="currentUser && currentUser.acl && (currentUser.role === 'admin' || currentUser.role === 'master')")
    b-nav-item(ref="usage",@click="handleTab('usage')",:class="feature === 'usage' ? 'active' : ''")
      i.icon.fas.fa-info
      span ご利用情報
</template>

<script>
export default {
  data () {
    return {
      feature: null,
      currentUser: null
    }
  },
  watch: {
    feature (val) {
      this.$parent.feature = val
    }
  },
  mounted () {
    const routes = this.$route.path.split('/').slice(1)
    if (routes.length > 2) {
      this.feature = routes[2]
    }

    this.loadData()
  },
  methods: {
    handleTab (feature) {
      this.feature = feature
      this.handleLink(`/${this.$route.params.directory}/setup/${feature}`)
    },
    loadData () {
      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.loadData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)
    }
  }
}
</script>

<style scoped lang="stylus">
.nav
  .nav-item
    &.active, &.active a
      //pointer-events none
      //cursor default
</style>
